import { createGlobalStyle } from 'styled-components';
// import 'leaflet/dist/leaflet.css';
import myFontURLWoff2 from '../../assets/typegraphic/nunito-v16-latin-regular.woff2';
import myFontURLWoff from '../../assets/typegraphic/nunito-v16-latin-regular.woff';
import myFontURLSafari from '../../assets/typegraphic/nunito-v16-latin-regular.ttf';
import myFontURLLegacy from '../../assets/typegraphic/nunito-v16-latin-regular.svg';

const GlobalStyle = createGlobalStyle`
    * {
    margin: 0;
    padding: 0;
    box-sizing: border-box
  }
   /* nunito-regular - latin */
@font-face {
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local('Nunito'), local('Nunito'),
   url(${myFontURLWoff2}) format('woff2'), /* IE9 Compat Modes */
   url(${myFontURLWoff}) format('woff'), /* Modern Browsers */
   url(${myFontURLSafari}) format('truetype'), /* Safari, Android, iOS */
   url(${myFontURLLegacy}) format('svg'); /* Legacy iOS */
}

.leaflet-container {
        margin-top: 200px;
        height: 400px;
        width: 100%;
        margin: 0 auto;
      }

      .my-loading {
  position: relative;
  overflow: hidden;
}

.my-loading::before,
.my-loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.my-loading::before {
  background-color: #f0f0f0db; /* Fondo sólido para ocultar el contenido */
  z-index: 1;
}

.my-loading::after {
  background: linear-gradient(
    90deg,
    transparent,
    rgba(64, 70, 77, 0.2),
    transparent
  );
  z-index: 2;
  animation: sweep 1.5s ease-in-out infinite;
}

@keyframes sweep {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

html {
        font-family: 'Nunito';
        line-height: 1.15;
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
         -ms-overflow-style: scrollbar;
        -webkit-tap-highlight-color: rgba(34, 42, 66, 0); }
        *, *::before, *::after {
                box-sizing: inherit;
        }
        ul, li, h1, h2, h3, p, button {
                margin: 0;
                padding: 0;
        }
        ul {
                list-style: none;
        }
        button {
                background: transparent;
                border: 0;
                outline: 0;
        }
        #app {
                //box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
                overflow-x: hidden;
                //min-height: 100vh;
                //padding-bottom: 10px;
        }

        /* Estilos para la sección de modelos asignados */
        .models-section {
          margin-top: 2rem;
        }

        .models-container {
          margin-top: 1rem;
          background: #1e293b;
          border-radius: 12px;
          padding: 1.5rem;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .models-grid {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .model-type-section {
          border-bottom: 1px solid #334155;
          padding-bottom: 1.5rem;
        }

        .model-type-section:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .model-type-title {
          font-size: 1.125rem;
          font-weight: 600;
          color: #e2e8f0;
          margin-bottom: 1rem;
          text-align: center;
          text-transform: capitalize;
        }

        .models-list {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .model-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 0.75rem;
          background: #334155;
          border: 1px solid #475569;
          border-radius: 8px;
          transition: all 0.2s ease;
        }

        .model-item:hover {
          border-color: #3b82f6;
          background: #3b82f6;
          box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
        }

        .model-checkbox-container {
          position: relative;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .model-checkbox {
          color: #60a5fa !important;
        }

        .model-loading-spinner {
          color: #94a3b8 !important;
        }

        .model-info {
          flex: 1;
        }

        .model-name {
          font-size: 0.875rem;
          font-weight: 500;
          color: #e2e8f0;
        }

        /* Layout de 3 filas horizontales */
        .details-grid {
          display: flex;
          flex-direction: column;
          gap: 2rem;
        }

        .full-width {
          width: 100%;
        }

        .users-section,
        .models-section,
        .budget-section {
          width: 100%;
        }
        
`;

export default GlobalStyle;
